import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const addDocsOrgToDoc = async ({ docId, orgId }) => {
  const dataParams = {
    id: Number(orgId),
  };
  const dataBody = {
    id: Number(docId),
    orgId: Number(orgId),
  };
  return await request.post(
    `/Docs/addOrgToDoc/${docId}`,
    dataBody,
    'При изменении добавлении адресата произошла ошибка документа произошла ошибка',
    'Error'
  );
};

const useAddDocsOrgToDoc = () => {
  const mutation = useMutation(addDocsOrgToDoc, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocsOrgToDoc: mutation.isLoading,
    addDocsOrgToDoc: mutation.mutateAsync,
  };
};

export default useAddDocsOrgToDoc;
